import React from 'react';
import { Box, Typography } from '@mui/material';

interface CalendarWithDateProps {
  start: Date;
  end: Date;
  showTime?: boolean;
  color?: string;
}

const CalendarWithDate: React.FC<CalendarWithDateProps> = ({
  start,
  end,
  showTime = false,
  color = 'blue', 
}) => {

  const startMonth = start.toLocaleString('default', { month: 'long' });
  const startDay = start.getDate();
  const startTime = start.toLocaleTimeString('default', { hour: '2-digit', minute: '2-digit' });
  const startYear = start.getFullYear();

  const endMonth = end.toLocaleString('default', { month: 'long' });
  const endDay = end.getDate();
  const endTime = end.toLocaleTimeString('default', { hour: '2-digit', minute: '2-digit' });
  const endYear = end.getFullYear();

  const isSameDay = startMonth === endMonth && startDay === endDay;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: 140,
        borderRadius: 2,
        boxShadow: 3,
        border: `2px solid ${color}`,
        padding: 2,
      }}
    >
      {/* Start Date */}
      <Box
        sx={{
          textAlign: 'center',
          marginBottom: 1,
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: 'bold', color: color }}
        >
          {isSameDay ? 'DATE' : 'START'}
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 'bold', color: '#000' }}
        >
          {startMonth.toUpperCase()} {startDay}
        </Typography>
        {new Date().getFullYear() !== startYear && (
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 'bold', color: '#000' }}
          >
            {startYear}
          </Typography>
        )}
        {!isSameDay && showTime && <Typography
          variant="body2"
          sx={{ color: '#000' }}
        >
          {startTime}
        </Typography>}
      </Box>

      {/* Divider */}
      {!isSameDay && (
        <Box
          sx={{
            width: '80%',
            height: '2px',
            backgroundColor: color,
            marginY: 1,
          }}
        ></Box>
      )}

      {/* End Date */}
      {!isSameDay && (
        <Box
          sx={{
            textAlign: 'center',
            marginTop: 1,
          }}
        >
          <Typography
            variant="subtitle2"
            sx={{ fontWeight: 'bold', color: color }}
          >
            END
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 'bold', color: '#000' }}
          >
            {endMonth.toUpperCase()} {endDay}
          </Typography>
          {new Date().getFullYear() !== startYear && (
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 'bold', color: '#000' }}
            >
              {startYear}
            </Typography>
          )}
          {showTime && <Typography
            variant="body2"
            sx={{ color: '#000' }}
          >
            {endTime}
          </Typography>}
        </Box>
      )}

      {/* Time range for same day */}
      {isSameDay && startTime && endTime && showTime && (
        <Typography variant="subtitle2" sx={{ color: '#000', textAlign: 'center' }}>
          {startTime} - {endTime}
        </Typography>
      )}
    </Box>
  );
};

export default CalendarWithDate;
